import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["filter", "rowSlot", "drawerSlot"]

  connect() {
    this.rowSlotByFilter = new Map(this.filterTargets.map((filter) => [
      filter,
      this.rowSlotTargets.find((rowSlot) => rowSlot.dataset.filter === filter.dataset.filter)
    ]))
    if (typeof ResizeObserver === "undefined") return

    this.resizeObserver = new ResizeObserver(() => {
      window.cancelAnimationFrame(this.placementFrame)
      this.placementFrame = window.requestAnimationFrame(() => this.placeFilters())
    })
    this.resizeObserver.observe(this.element)
  }

  disconnect() {
    window.cancelAnimationFrame(this.placementFrame)
    this.resizeObserver?.disconnect()
  }

  placeFilters() {
    if (!this.hasDrawerSlotTarget) return

    const rem = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16
    const formWidth = this.element.clientWidth
    const drawerFilters = this.filterTargets.filter((filter) => formWidth < Number(filter.dataset.moveBelow) * rem)

    this.rowSlotByFilter.forEach((rowSlot, filter) => {
      if (!drawerFilters.includes(filter) && filter.parentElement !== rowSlot) rowSlot.append(filter)
    })
    const drawerChildren = Array.from(this.drawerSlotTarget.children)
    if (drawerFilters.some((filter, index) => drawerChildren[index] !== filter)) this.drawerSlotTarget.append(...drawerFilters)

    this.rowSlotByFilter.forEach((rowSlot, filter) => { rowSlot.hidden = !rowSlot.contains(filter) })
    this.drawerSlotTarget.hidden = drawerFilters.length === 0
  }
}
